import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import './BroadcastLoadingState.css';

interface BroadcastLoadingStateProps {
  count?: number;
}

/**
 * Индикатор загрузки pending broadcasts
 * Показывается пока загружаются уведомления
 * Рендерится через Portal в body для корректной работы backdrop-filter
 */
const BroadcastLoadingState: React.FC<BroadcastLoadingStateProps> = ({ count }) => {
  const { t } = useTranslation();
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => (prev.length >= 3 ? '' : prev + '.'));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  // Рендерим через Portal напрямую в body для корректной работы backdrop-filter
  return ReactDOM.createPortal(
    <div className="broadcast-loading-overlay">
      <div className="broadcast-loading-content">
        <div className="loading-spinner"></div>
        <div className="loading-text">
          {t('broadcast.loadingNotifications')}{dots}
        </div>
        {count !== undefined && count > 0 && (
          <div className="loading-count">
            {t('broadcast.found')}: {count}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default BroadcastLoadingState;
